<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="text-center" style="padding: 50px 0">
          <img alt="IzOnay" src="../assets/logo.png" />
        </div>

        <form @submit.prevent="getAccount()" :disabled="loading">
          <div class="mb-3">
            <label for="accountCode" class="form-label">Hesap Kodu</label>
            <input
              ref="accountCode"
              type="text"
              v-model="code"
              class="form-control form-control-lg"
              id="accountCode"
              required
              aria-describedby="accountCodeHelp"
            />
            <!-- <div id="accountCodeHelp" class="form-text">Hesap kodunuzu giriniz.</div> -->
          </div>
          <div class="mb-3">
            <label for="email" class="form-label">E-Posta</label>
            <input
              type="email"
              v-model="email"
              class="form-control form-control-lg"
              id="email"
              required
            />
          </div>
          <div class="d-grid gap-2">
            <input type="submit" class="btn btn-primary btn-lg" value="Devam" />
          </div>
        </form>

        <div v-show="isExternalLoginAvailable" class="row m-5" id="external-logins">
            <div class="col-md-12">   
                <div class="text-center">             
                    <h6>Veya şununla oturum açın:</h6>
                </div>
            </div>
            <div v-if="isADFSLoginEnabled" class="col">
                <LoginWithADFS></LoginWithADFS>
            </div>
            <div v-else class="col">
                <LoginWithMicrosoft></LoginWithMicrosoft>
            </div>
        </div>


      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import LoginWithMicrosoft from '@/components/Login/LoginWithMicrosoft.vue'
import LoginWithADFS from '@/components/Login/LoginWithADFS.vue'

export default {
  data() {
    return {
      loading: false,
      code: "",
      email: ""
    };
  },
    components:{
        LoginWithMicrosoft,
        LoginWithADFS
    },
  computed: {
        isADFSLoginEnabled(){
            return window.settings.authentication?.adfs?.enabled;
        },
        isAzureLoginEnabled(){
            return window.settings.authentication?.adfs?.enableAzure;
        },
        isExternalLoginAvailable()
        {
            if(!this.isOnPrem || this.isADFSLoginEnabled  || this.isAzureLoginEnabled)
                return true;
            
            return false;
        }
  },
  methods: {
    getAccount() {
      if (!this.code) {
        this.$refs.accountCode.focus();
        return;
      }

      this.loading = true;
      axios
        .get("/onpremaccount/get?code=" + this.code)
        .then(x => {
          console.log(x);
          if (x.data) {
            location.href = x.data.MobileAppUrl + "&" + this.email;
          } else {
            this.$router.push("/login/#" + this.code + "&" + this.email);
          }
        })
        .catch(() => {
          this.$izonayAlert("İşlem gerçekleştirilemedi.");
          this.loading = false;
        });
    }
  }
};
</script>
